<div class="notifications-dropdown-wrapper" [style.border-color]="wls.primaryColor">
  @for (item of alertsWithIcons; track $index) {
    <button class="notifications-dropdown-item" (click)="navigateByNotificationType(item.title)">
      <span class="notifications-dropdown-title">
        <mat-icon class="notifications-dropdown-title__icon" [svgIcon]="item.icon"></mat-icon>
        <ng-container [ngPlural]="item.count">
          <ng-template ngPluralCase="=1">
            <span class="notifications-dropdown-title__text">{{
              'base-layout.user-notifications.' + item.title + '.single'
                | translate: { count: item.count }
            }}</span>
          </ng-template>
          <ng-template ngPluralCase="other">
            <span class="notifications-dropdown-title__text">{{
              'base-layout.user-notifications.' + item.title + '.plural'
                | translate: { count: item.count }
            }}</span>
          </ng-template>
        </ng-container>
      </span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  }
  @if (alertsWithIcons.length && mobilityBudgetAlertsWithIcons.length) {
    <mat-divider></mat-divider>
  }
  @for (item of mobilityBudgetAlertsWithIcons; track $index) {
    <button class="notifications-dropdown-item" (click)="navigateByNotificationType(item.title)">
      <span class="notifications-dropdown-title">
        <mat-icon class="notifications-dropdown-title__icon" [svgIcon]="item.icon"></mat-icon>
        <ng-container [ngPlural]="item.count">
          <ng-template ngPluralCase="=1">
            <span class="notifications-dropdown-title__text">{{
              'base-layout.user-notifications.' + item.title + '.single'
                | translate: { count: item.count }
            }}</span>
          </ng-template>
          <ng-template ngPluralCase="other">
            <span class="notifications-dropdown-title__text">{{
              'base-layout.user-notifications.' + item.title + '.plural'
                | translate: { count: item.count }
            }}</span>
          </ng-template>
        </ng-container>
      </span>
      <mat-icon>chevron_right</mat-icon>
    </button>
  }
</div>